import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-content-about',
  templateUrl: './content-about.component.html',
  styleUrls: ['./content-about.component.scss']
})
export class ContentAboutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
